import React, { useState, useEffect } from 'react';
import DeleteWarningForm from './deletewarning.js';
import SuperUserRequestForm from "./superUserRequest.js";
import "../css/eventsList.css";
import {BASE_URL} from "../constants";
import { useLanguage } from "../components/Language.js";

function SingleLocationForm({location_data, onClose}) {

    const [isWarningVisible, setIsWarningVisible] = useState("");
    const [isSuperUserVisible, setIsSuperUserVisible] = useState("");

    const user = JSON.parse(sessionStorage.getItem("USER"));

    console.log("username: ", user.username);

    const location = location_data[0]

    const {language} = useLanguage();

    const translations = {
        en: {
            deleteLocation: "Delete Location",
            SuperUserRequest: `Request to become a superuser of ${location.name}`,
            close: "Close",
               
        },

        gd: {
            deleteLocation: "Dubh às an t-àite",
            SuperUserRequest: `Iarr a bhith nad àrd-chleachdair de ${location.name}`,
            close: "Dùin",
        },
    };

    const handleRequestSuperUser = () => {
        setIsSuperUserVisible(true);
      };

    const handleDeleteLocationClick = () => {
        setIsWarningVisible(true);
      };

      const handleCancel = () => {
        setIsWarningVisible(false);
      };

      const handleClose = () => {
        setIsSuperUserVisible(false);
      }

    const handleConfirmDelete = async (id) => {

        console.log("In handle confirm delete");
            
        const response = await fetch(`${BASE_URL}/api/delete_location/`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({ location_name:id }),
        });
        
        if (response.ok) {
              
        console.log(id, "has now been deleted");
        setIsWarningVisible(false);
        onClose();
        } 
        };

    return(
        <div className="event-card">

        <h4 className = "event-title">{location.name} </h4>

        {user && (
                <>
                    <button onClick={() => handleDeleteLocationClick(location.name)}>
                    {translations[language].deleteLocation}
                    </button>
                    
                    <button onClick={() => handleRequestSuperUser()}>
                    {translations[language].SuperUserRequest}
                    </button>
                </>
            )}

        <button onClick={onClose}>{translations[language].close}</button>

        {isWarningVisible && (
            <div>
            <DeleteWarningForm
                deleteInfo={location.name}
                onCancel={handleCancel}
                onConfirm={() => handleConfirmDelete(location.name)}
            />
            </div>
          )}

        {isSuperUserVisible && (
            <div>
            <SuperUserRequestForm
                username = {user.username}
                locationName ={location.name}
                onCancel={handleClose}

            />
            </div>
        )}

        </div>
    )
}

export default SingleLocationForm;
